import { useCallback, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';

import { useQueryKeys } from '@/shared/hooks/use-query-keys';
import { useDiscoveryStore } from '../stores/discovery-store';

type UseStopDiscoverySearchParams = {
  sessionId: string;
  searchId?: string | null;
};

export function useStopDiscoverySearch({ sessionId, searchId }: UseStopDiscoverySearchParams) {
  const queryClient = useQueryClient();
  const queryKeys = useQueryKeys();
  const { setIsSearching } = useDiscoveryStore();
  const [stoppedSearchKey, setStoppedSearchKey] = useState<string | null>(null);

  const searchKey = searchId ? `${sessionId}:${searchId}` : null;
  const isStopped = searchKey != null && stoppedSearchKey === searchKey;

  const stopSearch = useCallback(() => {
    if (!searchId || !searchKey) return;

    setStoppedSearchKey(searchKey);
    setIsSearching(false);

    void queryClient.cancelQueries({
      queryKey: queryKeys.discovery.searchStatus(sessionId, searchId),
    });
  }, [queryClient, queryKeys, searchId, searchKey, sessionId, setIsSearching]);

  return {
    isStopped,
    stopSearch,
  };
}
